import { blockedEmailDomains } from '../config/appConfig';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmailFormat(email: string): boolean {
    return EMAIL_RE.test(email.trim());
}

export function getEmailDomain(email: string): string {
    return email.trim().toLowerCase().split('@')[1] ?? '';
}

/**
 * Enforce corporate-domain sign-up: reject well-known personal email domains.
 * Returns an error message string, or null if the email is acceptable.
 */
export function validateCorporateEmail(email: string): string | null {
    if (!isValidEmailFormat(email)) {
        return 'Enter a valid email address.';
    }
    const domain = getEmailDomain(email);
    if (blockedEmailDomains.includes(domain)) {
        return 'Use your company email address. Personal email domains are not allowed.';
    }
    return null;
}

/**
 * Basic password strength guard for the prototype. Cognito enforces its own
 * policy server-side; this gives fast client-side feedback.
 */
export function validatePassword(password: string): string | null {
    if (password.length < 8) {
        return 'Password must be at least 8 characters.';
    }
    if (!/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/[0-9]/.test(password)) {
        return 'Password must include upper and lower case letters and a number.';
    }
    return null;
}
